import { Component, OnInit, Input } from '@angular/core';
import { StorageService } from 'src/app/services/storage.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'btn-listar-desejo',
  templateUrl: './btn-listar-desejo.component.html',
  styleUrls: ['./btn-listar-desejo.component.scss']
})
export class BtnListarDesejoComponent implements OnInit {

  @Input("id") id  = null;
  public usuario   = null;
  public loader    = false; 

  constructor(
    public storage: StorageService,
    public usuarioService: UsuarioService,
    private api: ApiService,
    private app: AppService
  ){ }
  /**
   * 
   * Listar
   * 
   */
  _listar(){

    try{
      
      this.loader = true;

      this.api.produto().listar_desejo(this.id).subscribe(response => {

        this.loader = false;

      },(response) => {

        this.loader = false;

      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * On Data
   * 
   */
  onData(){

    this.usuarioService.emitUsuarioLogin.emit(usuario => {
      this.usuario = usuario;
    }); 

  }
  /**
   * 
   * Seta o usuário
   * 
   */
  setUsuario(){ 

    this.usuario = this.storage.getUsuario(); 

  }
  /**
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.onData();
    this.setUsuario();
  }

}
